'use client';
import PageLayout from "../PageLayout";
import { useParams } from 'next/navigation';
import { getVsById } from "./vs/vs";
import { useTranslation } from "react-i18next";
import { defaultLang, SUPPORTED } from "../../config/languages";
import { COMPARE_SECTION } from "../../config/compareSections";
import JsonLd from '@/components/JsonLd';
import { COMPANY_DATA } from '../../config/companyData';
import SingleVsLayout2 from './SingleLayout2';

export default function SingleVs() {
  const { slug, lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const section = COMPARE_SECTION[activeLang] || 'compare';
  const { t } = useTranslation(["vs", "call_to_action", "support"]);
  const item = getVsById(slug);

  if (!item) {
    return <PageLayout presentLikeHome title={t('support:not_found.title', 'Page not found')} metaDescription={t('support:not_found.description', 'The page does not exist.')} noindex><main className="blog-v2-page"><h1>{t('support:not_found.title', 'Page not found')}</h1></main></PageLayout>;
  }

  const tr = item.translations?.[activeLang] || item.translations?.en || item;
  const imageUrl = item.image?.startsWith("http") ? item.image : `https://www.adcast.app${item.image || ""}`;
  const slugFinal = typeof item.slug === 'string' ? item.slug : (item.slug[activeLang] || item.slug.en);
  const url = `https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/${section}/${slugFinal}`;
  const content = tr.content || item.content || "";
  const labels = {
    appStoreAria: t('call_to_action:labels.app_store_aria', 'Download AdCast on App Store'),
    appStoreAlt: t('call_to_action:labels.app_store_alt', 'Download AdCast from App Store'),
    googlePlayAria: t('call_to_action:labels.google_play_aria', 'Get AdCast on Google Play'),
    googlePlayAlt: t('call_to_action:labels.google_play_alt', 'Download AdCast from Google Play Store'),
  };
  const breadcrumb = {"@context":"https://schema.org","@type":"BreadcrumbList",itemListElement:[
    {"@type":"ListItem",position:1,name:t('vs:title'),item:`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/${section}`},
    {"@type":"ListItem",position:2,name:tr.title,item:url}
  ]};
  const articleSchema = {"@context":"https://schema.org","@type":"Article",headline:tr.title,description:tr.description,image:imageUrl,datePublished:tr.datePublished || item.datePublished,dateModified:tr.dateModified || item.dateModified,author:{"@type":"Organization",name:COMPANY_DATA.name},publisher:{"@type":"Organization",name:COMPANY_DATA.name,logo:{"@type":"ImageObject",url:"https://www.adcast.app/adcast.svg"}},mainEntityOfPage:url,url};

  return (
    <PageLayout presentLikeHome title={tr.title} metaDescription={tr.description} canonical={url} ogType="article" ogImage={imageUrl}>
      <JsonLd data={breadcrumb} id="breadcrumb-jsonld" />
      <JsonLd data={articleSchema} id="article-jsonld" />
      <SingleVsLayout2 item={item} title={tr.title} description={tr.description} content={content} labels={labels} slug={slugFinal} activeLang={activeLang} guidesTitle={t('vs:guidesAndResources')} compareTitle={t('vs:title')} />
    </PageLayout>
  );
}
